import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Analytics from 'analytics-opencare';
import { useAnalyticsService } from 'services/AnalyticsService';

import { COUNTRY } from '../../../../../../common/constants';
import { useFunnelStorage } from '../../../../storage/Storage';
import { generateStepAnalytics, STEP_KEY } from '../../../../utils';

import AmericaInsuranceProvider from './AmericaInsuranceProvider';
import CanadianInsurance from './CanadianInsurance';

const analytics = new Analytics();

const Details = ({ position, moveToNextStep, setSubStep }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const location = storage.get(STEP_KEY.LOCATION);
  const [country, setCountry] = useState(null);

  useEffect(() => {
    setCountry(get(location, 'address.country'));
  }, [location]);

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_insurance-plan',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  return (
    <div data-testid="substep-details">
      {country === COUNTRY.canada
        && (
          <CanadianInsurance
            position={position}
            moveToNextStep={moveToNextStep}
            setSubStep={setSubStep}
          />
        )
      }
      {country === COUNTRY.unitedStates
        && (
          <AmericaInsuranceProvider
            position={position}
            moveToNextStep={moveToNextStep}
            setSubStep={setSubStep}
          />
        )
      }
    </div>
  );
};

Details.defaultProps = {
  position: '',
};

Details.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
  setSubStep: PropTypes.func.isRequired,
};

export default Details;
